import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Error from '../../components/Error';

import * as organizationConstants from '../../constants/organizations';
import * as organizationSelectors from '../../selectors/organizationSelectors';
import * as newBucketSelectors from '../../selectors/newBucketSelectors';

const NewBucketModal = props => {
    const {
        show,
        name,
        description,
        loading,
        error,
        isValid,
        onNameChange,
        onDescriptionChange,
        onCreateNew,
        onClose,
        classes,
    } = props;

    const isFormDisabled = !!loading || !isValid;
    let createButton, cancelButton, loadingIndicator;
    if (!loading) {
        cancelButton = <Button onClick={onClose}>CANCEL</Button>;
        createButton = (
            <Button
                onClick={onCreateNew}
                color="primary"
                variant="contained"
                disabled={isFormDisabled}
            >
                CREATE PROJECT
            </Button>
        );
    } else {
        loadingIndicator = <CircularProgress />;
    }

    return (
        <Dialog open={show} onClose={onClose}>
            <DialogTitle>Create new project</DialogTitle>
            <DialogContent>
                <div className={classes.content}>
                    <TextField
                        required
                        label="Project name"
                        value={name}
                        onChange={onNameChange}
                        onKeyPress={event => {
                            if (event && event.key === 'Enter' && name !== '') {
                                onCreateNew(event);
                            }
                        }}
                    />
                    <TextField
                        multiline
                        rows="10"
                        label="Project description"
                        value={description}
                        inputProps={{
                            maxLength: 350,
                        }}
                        onChange={onDescriptionChange}
                    />
                    <Error>{error}</Error>
                    {loadingIndicator}
                </div>
            </DialogContent>
            <DialogActions>
                {cancelButton}
                {createButton}
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        organization: organizationSelectors.getOrganization(state),
        name: newBucketSelectors.getBucketName(state),
        description: newBucketSelectors.getBucketDescription(state),
        error: newBucketSelectors.getError(state),
        loading: newBucketSelectors.getLoading(state),
        isValid: newBucketSelectors.getIsFormValid(state),
        visibleInApplications: newBucketSelectors.getVisibleInApplications(
            state,
        ),
    };
};

const mapDispatchToProps = dispatch => ({
    onNameChange: event =>
        dispatch({
            type: organizationConstants.CHANGE_NEW_BUCKET_NAME,
            payload: event.target.value,
        }),
    onDescriptionChange: event =>
        dispatch({
            type: organizationConstants.CHANGE_NEW_BUCKET_DESCRIPTION,
            payload: event.target.value,
        }),
    onCreateNew: e => {
        e.preventDefault();
        dispatch({
            type: organizationConstants.NEW_BUCKET_REQUEST,
        });
    },
});

NewBucketModal.propTypes = {
    organization: PropTypes.object.isRequired,
    visibleInApplications: PropTypes.array.isRequired,
    name: PropTypes.string,
    loading: PropTypes.bool,
    isValid: PropTypes.bool,
    error: PropTypes.object,
    show: PropTypes.bool,
    onClose: PropTypes.func,
};

NewBucketModal.defaultProps = {
    name: '',
    loading: false,
    isValid: false,
    error: undefined,
    show: false,
};

const style = ({ spacing }) => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
    },
    icon: {
        composes: ['material-icons'],
        marginRight: spacing.unit,
    },
    createProjectButton: {
        borderRadius: '50%',
        minWidth: '60px', // Overrides Material-UI min-width: 64px
        height: '60px',
        boxShadow: '0 0 6px 0 rgba(0,0,0,0.12), 0 6px 6px 0 rgba(0,0,0,0.24)',
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectSheet(style)(NewBucketModal));



// WEBPACK FOOTER //
// ./src/containers/organizationBuckets/NewBucketModal.js